import { ScrollTop } from '@/components/element/ScrollTop';
import { InvoiceTaskEditForm } from '@/components/features/tasks/invoice/[invoice_task_id]/InvoiceTaskEditForm';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useCurrentInvoiceTask } from '@/providers/InvoiceTaskProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const BackofficeInvoiceTaskEdit = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle(`請求タスク編集`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `請求タスク一覧`, path: `/w/${_w_!.identifier}/backoffice/invoice_tasks` },
        {
          label: `請求タスク詳細`,
          path: `/w/${_w_!.identifier}/backoffice/teams/${_t_!.id}/sales_orders/${sales_order_id}/invoice_tasks/${task!.id}`,
        },
      ]),
    []
  );

  const { sales_order_id } = useParams();
  const { invoiceTask: task } = useCurrentInvoiceTask();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <InvoiceTaskEditForm />
    </WorkspaceLayout>
  );
};
